

// ============================
// CONFIGURACIÓN CALENDARIO
// ============================
const PARQUE_CERRADO = "parque-cerrado";
let   PARQUE_ABIERTO = "parque-abierto";
const LABEL_CERRADO = "Parque Cerrado";
const LABEL_ABIERTO = "parque abierto";
let   LABEL_DISPONIBLE = "pasaporte disponible";
const LABEL_NO_DISPONIBLE = "pasaporte no disponible";
const PASAPORTE_NO_DISPONIBLE = "sin-pasporte";

const FORMATO_FECHA_CALENDARIO = "m/d/yy";

// ► RANGO: hoy → 31 de diciembre de 2026
const HOY = new Date();
HOY.setHours(0,0,0,0);
const MAXIMO_FECHAS_MOSTRAR = new Date(2026, 11, 31); // 31/dic/2026

let fechasDeshabilitadas = []; // YYYY-MM-DD cerrados (derivadas de tu `fechas`)
let fechasPasaporte = [];      // YYYY-MM-DD disponibles p/ pasaporte (si activas esa lógica)
let colorPasaporte = "#B7B7B7";
let isOpen = false;
let isTerra = true; // usa verificarDisponibilidad (abierto/cerrado simple)

// --- EXCEPCIÓN: SIEMPRE ABIERTO 24/09 del año actual ---
const Y_ACTUAL = new Date().getFullYear();
const EXCEPCIONES_ABIERTAS = new Set([`${Y_ACTUAL}-09-24`]);
function esExcepcionAbiertaISO(iso) { return EXCEPCIONES_ABIERTAS.has(iso); }

// ============================
// MAPAS / IDs / CLASES
// ============================
const UrlsPasaporte = {
  FECHAS_TERRA: "https://grupopanaca.com.do/EscenarioApi/api/calendario",
};

const ClasesPasaporte = {
  ABIERTO:"parque-abierto",
  travesia :"pasaporte-travesia",
  NATURA : "pasaporte-natura",
  TERRA : "pasaporte-terra",
  TERRA_NINO : "pasaporte-terra-nino",
  GRANJERO : "pasaporte-granjero",
  CAMPO: "pasaporte-campo",
  TERRA_NATURA :"pasaporte-natura",
};

const IdsPasaportes = {
  ABIERTO:"8561612685531a",
  TERRA: "8561612685531",
  travesia: "8561613471963",
  NATURA: "8561616388315",
  GRANJERO: "8680180711643",
  INFANTIL: "8675970285787",
  CAMPO: "8561615274203",
  CAMPOINFANTIL: "8752678502619",
  TERRA_NATURA: "8561617535195",
  FIESTA: "9393078534427",
  PLAZA: "9393078534427"
};

const ColorPasaporte = {
  TERRA:"#116736",
  TERRA_NINO : "#EC890A",
  NATURA : "#116736",
  travesia : "#AC6B3A",
  GRANJERO : "#E2725B",
  ABIERTO: "#e8f5e9", /* match .parque-abierto (celdas disponibles) */
};

const Pasaportes = {
  ABIERTO:"Parque Abierto",
  TERRA :"Pasaporte Terra",
  TERRA_NINO :"Pasaporte Terra Niño",
  NATURA : "Pasaporte Natura",
  travesia : "Pasaporte Travesía",
  GRANJERO : "Pasaporte Granjero",
  CAMPO : "Pasaporte Campo",
  TERRA_NATURA : "Pasaporte Terra + Natura",
};

// ============================
// UTILIDADES DE FECHA
// ============================
function formatearFecha(fecha) {
  const year = fecha.getFullYear();
  const month = String(fecha.getMonth() + 1).padStart(2, '0');
  const day = String(fecha.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function formatoFechaMesDiaAnio(lista) {
  return (Array.isArray(lista) ? lista : []).map((item) => {
    if (item?.Fecha) {
      const [mes, dia, anio] = item.Fecha.split('/');
      return `${anio}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    }
    return null;
  }).filter(Boolean);
}

function obtnerFechaLarga(fecha){
  const f = new Date(fecha);
  const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
  return f.toLocaleDateString('es-ES', opciones);
}

// ============================
// CARGA DE CERRADOS (DESDE TU VARIABLE GLOBAL `fechas`)
// ============================
async function diaCerrado() {
  try {
    // Usa tu variable global `fechas` (formato m/d/yyyy en item.Fecha)
    const base = Array.isArray(fechas) ? fechas : [];

    // Convierte a ISO y aplica excepciones
    const fechasConvertidas = formatoFechaMesDiaAnio(base);
    fechasDeshabilitadas = fechasConvertidas.filter(f => !esExcepcionAbiertaISO(f));
  } catch(error){
    // En caso de error, no bloquea nada
    fechasDeshabilitadas = [];
  }
}

// ============================
// OBTENER FECHAS DESDE URL (utilitario, por si lo usas)
// ============================
async function obtenerFechas(url){
  try{
    const respuesta = await fetch(url);
    if(!respuesta.ok){
      if (respuesta.status === 404) throw new Error('404 Not Found');
      throw new Error(`Error: ${respuesta.status} ${respuesta.statusText}`);
    }
    return await respuesta.json();
  }catch{
    return '404 Not Found';
  }
}

// ============================
// beforeShowDay: CERRADO/ABIERTO simple
// ============================
function verificarDisponibilidad(date) {
  const formatted = formatearFecha(date); // YYYY-MM-DD
  if (date < HOY) return [true, 'fecha-anterior', 'Fecha Anterior'];

  // EXCEPCIÓN: siempre abierto
  if (esExcepcionAbiertaISO(formatted)) return [true, PARQUE_ABIERTO, LABEL_ABIERTO];

  if (fechasDeshabilitadas.includes(formatted)) return [false, PARQUE_CERRADO, LABEL_CERRADO];

  // Bloqueo POR PRODUCTO (evento especial / concierto): el escenario de un producto esta
  // ocupado y se deshabilita SOLO ese producto. Los demas (p. ej. Plaza/Fiesta) siguen
  // disponibles. window.ticketSelected se setea al elegir la carta de producto (carrito.liquid).
  const ticket = window.ticketSelected || (window.ticketSelectedArray ? window.ticketSelectedArray[0] : null);
  if (ticket == 8 || ticket == 9 || ticket == 10) {
    if (Array.isArray(window.DIAS_BLOQUEO_TRAVESIA) && window.DIAS_BLOQUEO_TRAVESIA.includes(formatted)) return [false, 'evento-bloqueado', 'Escenario ocupado (Concierto)'];
  } else if (ticket == 7) {
    if (Array.isArray(window.DIAS_BLOQUEO_PLAZA) && window.DIAS_BLOQUEO_PLAZA.includes(formatted)) return [false, 'evento-bloqueado', 'Evento especial (Plaza Herencia)'];
  } else if (ticket == 6) {
    if (Array.isArray(window.DIAS_BLOQUEO_FIESTA) && window.DIAS_BLOQUEO_FIESTA.includes(formatted)) return [false, 'evento-bloqueado', 'Evento especial (Fiesta Dominicana)'];
  }

  return [true, PARQUE_ABIERTO, LABEL_ABIERTO];
}

// ============================
// beforeShowDay: lógica de PASAPORTES (si quisieras activarla)
// ============================
function fechasNodisponible(date) {
  const formattedDate = formatearFecha(date);

  if (esExcepcionAbiertaISO(formattedDate)) return [true, PARQUE_ABIERTO, LABEL_ABIERTO];
  if (fechasDeshabilitadas.includes(formattedDate)) return [false, PARQUE_CERRADO, LABEL_CERRADO];
  if (date < HOY) return [true, 'fecha-anterior', 'Fecha Anterior'];

  const esFechaPermitida = (fechasPasaporte || []).some(fecha => {
    const [anio, mes, dia] = fecha.split("-").map(n => parseInt(n,10));
    return date.getDate() === dia && date.getMonth() === (mes - 1) && date.getFullYear() === anio;
  });

  return esFechaPermitida
    ? [true, colorPasaporte, LABEL_DISPONIBLE]
    : [true, PASAPORTE_NO_DISPONIBLE, LABEL_ABIERTO];
}

// ============================
// onSelect: setea fecha y oculta modal
// ============================
function eventosCalendario(dateText, inst){
  const pasaportes = document.querySelectorAll(".section-pasaportes__slide-card");

  // ✅ No re-asignes la variable, usa el elemento
  const di = document.getElementById("dateInput");
  if (di) {
    di.value = dateText;
    di.textContent = dateText;
    di.dispatchEvent(new Event('change'));
  }
  /*
  if(dateInput.value == fechaEspecial){
    document.getElementById('textDiscount').style.display = "none"
  }else{
    document.getElementById('textDiscount').style.display = "flex"
  }*/

  const contCompra = document.getElementById('container-compra-ahora');
  const contBtns = document.getElementById('container-buttons');
  document.getElementById('btn-buy-header').style.display = "none"
  if (contCompra) contCompra.style.zIndex = '99999';
  if (contCompra) contCompra.style.display = 'flex';
  document.body.style.overflow = 'hidden';
  if (contBtns) {
    contBtns.style.zIndex = '99998';
    contBtns.style.display = 'flex';
  }

   // ticketSelected es un array, ej: [8], [9], [10]
  const ticketSel = window.ticketSelected || (window.ticketSelectedArray ? window.ticketSelectedArray[0] : null);
  const idSeleccionado = ticketSel;

  //Condicion
  if(idSeleccionado != 7 && idSeleccionado != 6){
      // 🔹 Guardar tipo de producto para uso posterior en escenario.liquid, como-llegar-map.js y graderia.js
      //    Esto corrige el bug donde seleccionar Travesía después de Plaza/Fiesta mostraba el producto
      //    anterior (valor stale en sessionStorage) y ocultaba el mapa de asientos.
      window.ticketSelectedProductType = idSeleccionado;
      sessionStorage.setItem('ticketSelectedProductType', idSeleccionado);
      window.dispatchEvent(new CustomEvent('ticketSelectedProductTypeChanged'));

      const btnLoad = document.getElementById('loadSillas');
      if (btnLoad) btnLoad.click();

    

      // 🔹 Mapeo de IDs a nombres
      let nombreZona = "";
      switch (Number(idSeleccionado)) {
        case 8:  nombreZona = "Experience"; break;
        case 9:  nombreZona = "Preferred";  break;
        case 10: nombreZona = "Premium";    break;
        default: nombreZona = "";           break;
      }

      // 🔹 Formateo final (primera letra mayúscula)
      const ticketSelectedShow = nombreZona
        ? nombreZona.charAt(0).toLocaleUpperCase('es-ES') + nombreZona.slice(1).toLocaleLowerCase('es-ES')
        : "";

      // 🔹 Actualizar el título de Travesía
      const primero = document.getElementById('primero');
      if (primero) primero.innerHTML = "Travesía " + ticketSelectedShow;

      // 🔹 Actualizar el label de tickets con el nombre del producto
      const ticketsLabel = document.getElementById('tickets-label');
      if (ticketsLabel) {
        ticketsLabel.textContent = "Travesía " + ticketSelectedShow + ":";
      }

      // 🔹 Mostrar label residente debajo del nombre del producto
      if (typeof actualizarLabelResidente === 'function') {
        actualizarLabelResidente();
      }

      // 🔹 Radios/checkbox por zona
      if (idSeleccionado != null) {
        ['10','9','8'].forEach(id => {
          const el = document.getElementById(id);
          if (el) el.checked = false;
        });
        const marcar = (id) => {
          const el = document.getElementById(String(id));
          if (el) el.checked = true;
        };
        if (idSeleccionado === 10) marcar(10);
        else if (idSeleccionado === 9) marcar(9);
        else if (idSeleccionado === 8) marcar(8);
      }

      // Atributo data-fecha en tarjetas
      pasaportes.forEach((pasaporte) => pasaporte.setAttribute("data-fecha", dateText));

      validarPasaportes(dateText);

      // Actualizar transporte según tipo de visitante
      if (typeof actualizarTransporteParaResidente === 'function') {
        actualizarTransporteParaResidente();
      }

      // Limpieza de modales/contenido especial
    // document.querySelectorAll('.openModalConcierto').forEach(el => el.remove());
  }else{
    // ========== BACKUP original: se llamaba openCar() directo para zonas 6 y 7 (líneas 258-267) ==========
    // ========== NUEVO: Pasar cantidades y actualizar título para que el usuario use el modal ==========
    // Logica para mostrar el modal de confirmación (igual que Travesía)

    // Mostrar el modal de compra
    const contCompra = document.getElementById('container-compra-ahora');
    if (contCompra) {
      contCompra.style.zIndex = '16';
      contCompra.style.display = 'flex';
    }
    document.body.style.overflow = 'hidden';

    const qtyCart = document.getElementById('qty-cart');
    const qtyCartChild = document.getElementById('qty-cart-child');
    const qtyAdultEl = document.getElementById(`${idSeleccionado}-qty`);
    const qtyNinoEl = document.getElementById(`${idSeleccionado}-child`);

    if (qtyCart && qtyAdultEl) {
      qtyCart.textContent = qtyAdultEl.textContent || '0';
      qtyCart.value = qtyAdultEl.textContent || '0';
    }
    if (qtyCartChild && qtyNinoEl) {
      qtyCartChild.textContent = qtyNinoEl.textContent || '0';
      qtyCartChild.value = qtyNinoEl.textContent || '0';
    }

    // Guardar tipo de producto para el cálculo posterior en graderia.js
    window.ticketSelectedProductType = idSeleccionado; // 6=fiesta, 7=herencia
    sessionStorage.setItem('ticketSelectedProductType', idSeleccionado); // Backup storage

    // Disparar evento para que otros scripts reaccionen
    window.dispatchEvent(new CustomEvent('ticketSelectedProductTypeChanged'));

    // Actualizar el título para mostrar el nombre del producto
    const primero = document.getElementById('primero');
    if (primero) {
      const serviceName = idSeleccionado === 6 ? "Fiesta Dominicana" : "Plaza Herencia Dominicana";
      primero.innerHTML = serviceName;
    }

    // Actualizar el label de tickets con el nombre del producto
    const ticketsLabel = document.getElementById('tickets-label');
    if (ticketsLabel) {
      const serviceNameLabel = idSeleccionado === 6 ? "Fiesta Dominicana" : "Plaza Herencia Dominicana";
      ticketsLabel.textContent = serviceNameLabel + ":";
    }

    // Ocultar mapa inmediatamente después de mostrar el modal
    // Usar setTimeout para asegurar que el DOM está listo
    setTimeout(() => {
      // Ocultar mapa y checkboxes - lógica directa
      if (idSeleccionado === 6 || idSeleccionado === 7) {
        const contenedorMapa = document.getElementById('contenedorMapa');
        if (contenedorMapa) contenedorMapa.style.display = 'none';
        const contenedorPrincipal = document.querySelector('.contenedor-principal');
        if (contenedorPrincipal) contenedorPrincipal.style.display = 'none';
        document.querySelectorAll('.checkPassports').forEach(cb => {
          const container = cb.closest('.container-check-label');
          if (container) container.style.display = 'none';
        });
      }
      // ========== NUEVO: Actualizar transporte y label residente ==========
      if (typeof actualizarTransporteParaResidente === 'function') {
        actualizarTransporteParaResidente();
      }
      if (typeof actualizarLabelResidente === 'function') {
        actualizarLabelResidente();
      }
      if (typeof showSubTotal === 'function') {
        showSubTotal();
      }
    }, 50);
    // ========== END NUEVO ==========
  }

  // fin Condicion
  ocultarModal();
}



// ============================
// CONFIG / INIT Datepicker
// ============================
function configuracionesCalendario(){
  return{
    dateFormat: FORMATO_FECHA_CALENDARIO,
    changeMonth: true,
    changeYear: true,
    minDate: HOY,
    maxDate: MAXIMO_FECHAS_MOSTRAR,
    beforeShowDay: verificarDisponibilidad, // lógica simple abierto/cerrado
    onSelect: eventosCalendario,
    language: 'es'
  };
}

async function inicializarDatepicker() {
  await diaCerrado(); // ► llena fechasDeshabilitadas desde TU `fechas`
  const cfg = configuracionesCalendario();
  $("#datepicker").datepicker(cfg);
}

// ============================
// VALIDACIÓN PASAPORTES (placeholder)
// ============================
async function validarPasaportes(/*fecha*/){
  // Si quisieras usar fechasPasaporte por tipo, llénala y usa fechasNodisponible
}

// ============================
// MODAL
// ============================
function cargarCalendario() {
  document.addEventListener('DOMContentLoaded', ()=>{
    const modal = document.querySelector('.modal');
    if (modal) modal.style.setProperty('display', 'flex');
  });
}

function ocultarModal() {
  const modal = document.querySelector("#myModal");
  ocultarChat();
  if (modal) {
    modal.style.display = 'none';
    modal.style.zIndex = ''; // restablecer z-index al valor CSS base (9999)
  }
}

function closeTextModal(){
   const m = document.getElementById('myModal');
   if (m) {
     m.style.display = "none";
     m.style.zIndex = ''; // restablecer z-index al valor CSS base (9999)
   }
   document.body.style.overflow = 'auto';
}

// ============================
// Nomenclaturas (UI) — NO toca `fechasDeshabilitadas`
// ============================
async function fechasDisponibilidadPasaporte(){
  const nomenclatura = document.querySelector(".color-nomenclatura__cerrado");
  const nombrePasaporte = document.querySelector(".etiqueta-nomenclatura");
  const diaSinPasporte = document.querySelector(".color-nomenclatura__abierto");
  const nomenClaturaOculta = document.querySelector(".fila-nomenclatura__oculto");

  if (nomenclatura) nomenclatura.style.setProperty("background-color", "#fff");
  if (diaSinPasporte) diaSinPasporte.style.setProperty("background-color", "red");

  // Estado base: Parque Abierto (leyenda UI)
  if (nombrePasaporte) nombrePasaporte.textContent = Pasaportes.ABIERTO;
  if (nomenclatura) nomenclatura.style.setProperty("background-color", ColorPasaporte.ABIERTO);
  colorPasaporte = ClasesPasaporte.ABIERTO;
  PARQUE_ABIERTO = "parque-abierto";
  isTerra = true;
  isOpen = true;
  LABEL_DISPONIBLE = Pasaportes.ABIERTO;
  if (nomenClaturaOculta) nomenClaturaOculta.style.setProperty("opacity", 0);

  // NO recalculamos `fechasDeshabilitadas` aquí
  renderizarCalendario(isTerra);
}

// ==========================
// Configuración (usa tu contenedor real si no es <body>)
// ==========================
var OBS_CONT_DATEPICKER = document.body;
var dpObserverIniciado = false;
var dpObserver = null;

// ==========================
// Helper: comprobar plugin y nodo
// ==========================
function pluginYNodoListos() {
  return !!(window.jQuery && $.fn && $.fn.datepicker && document.getElementById('datepicker'));
}

// ==========================
// Observer para re-inicializar si #datepicker reaparece/reemplaza
// ==========================
function onMutacionesDatepicker(mutationsList, observer) {
  var el = document.getElementById('datepicker');
  if (el && el.dataset.dpInit !== '1' && pluginYNodoListos()) {
    // Re-engancha usando el último valor de 'terra' que hayas usado; ajusta si necesitas otro
    renderizarCalendario(true);
  }
}

function iniciarObserverDatepicker() {
  if (dpObserverIniciado) return;
  dpObserver = new MutationObserver(onMutacionesDatepicker);
  dpObserver.observe(OBS_CONT_DATEPICKER, { childList: true, subtree: true });
  dpObserverIniciado = true;
}

// =============================
// FUNCIÓN: renderizarCalendario
// =============================
async function renderizarCalendario(terra, intentos) {
  // Valor por defecto si no se pasa
  if (typeof intentos !== 'number') intentos = 0;

  // (1) Esperar a que exista el plugin y el input
  if (!pluginYNodoListos()) {
    if (intentos > 30) return; // evita bucle infinito
    setTimeout(renderizarCalendario, 1000, terra, intentos + 1);
    return;
  }

    try {
      await diaCerrado();
    } catch (e) {
      if (intentos > 30) return;
      setTimeout(renderizarCalendario, 500, terra, intentos + 1);
      return;
    }

    var beforeFn = terra ? verificarDisponibilidad : fechasNodisponible;

      // (4) Revalidar nodo *después* del await
      var el = document.getElementById('datepicker');
      if (!el || !document.documentElement.contains(el)) {
        if (intentos > 30) return;
        setTimeout(renderizarCalendario, 500, terra, intentos + 1);
        return;
      }

  // (5) Reforzar que no sea null ni vacío
  if (!el) return;
  var $dp = jQuery(el);
  if (!$dp.length) return;

  // (6) Si el datepicker ya está inicializado, destruirlo con seguridad
  if ($dp.hasClass('hasDatepicker')) {
    try {
      $dp.datepicker('destroy');
    } catch (err) {
      console.warn('No se pudo destruir datepicker anterior:', err);
    }
  }

  // (7) Inicializar el nuevo datepicker
  try {
    $dp.datepicker({
  dateFormat: FORMATO_FECHA_CALENDARIO,
  changeMonth: true,
  changeYear: true,
  language: 'es',
  minDate: HOY,
  maxDate: MAXIMO_FECHAS_MOSTRAR,
  beforeShowDay: beforeFn,
  onSelect: eventosCalendario,
  onChangeMonthYear: function(){
    setTimeout(arreglarLinksDatepicker, 10);
  }
});
  } catch (errorInit) {
    console.error('Error al inicializar datepicker:', errorInit);
    if (intentos < 30) setTimeout(renderizarCalendario, 800, terra, intentos + 1);
    return;
  }

  // (8) Marcar el elemento como inicializado
  el.dataset.dpInit = '1';
arreglarLinksDatepicker();
  // (9) Iniciar observer solo una vez
  try {
    iniciarObserverDatepicker();
  } catch (observerErr) {
    console.warn('Error iniciando observer datepicker:', observerErr);
  }
}

// =============================
// FUNCIÓN: pluginYNodoListos()
// =============================
// Verifica que el plugin jQuery UI Datepicker y el nodo existan
function pluginYNodoListos() {
  return (
    typeof jQuery !== 'undefined' &&
    typeof jQuery.fn !== 'undefined' &&
    typeof jQuery.fn.datepicker === 'function' &&
    document.getElementById('datepicker')
  );
}


// ==========================
// Llamadas iniciales (ajusta 'true/false' según tu lógica)
// ==========================
iniciarObserverDatepicker();
renderizarCalendario(true);



// ============================
// LISTENERS GENERALES
// ============================
function clicksCalendarioPasaportes(){
  document.addEventListener('change', (event)=>{
    if (event.target.matches('.contenedor-eventos__select')) {
      fechasDisponibilidadPasaporte();
    }
  });
}

function clicsksDocument(){
  document.addEventListener('click', (event)=>{
    if (event.target.matches('.buttonCompraAhoraHeader, .section-pasaportes__redirecion')) {
      location.reload();
    }
  });
}

function ocultarChat() {
  const chatButton = document.querySelector("button.chat-toggle.chat-toggle--icon-button");
  if (chatButton) chatButton.style.display = "none";
}

document.addEventListener("click",(e)=>{
  if(e.target.className == "modal"){
    // aquí tu lógica si hace falta
  }
});

// ============================
// ARRANQUE
// ============================
clicksCalendarioPasaportes();
clicsksDocument();
inicializarDatepicker();       // ► lee TU `fechas` y crea el calendario (hoy → 30/jun/2026)
fechasDisponibilidadPasaporte(); // UI de leyenda (no toca cerrados)



async function openCar(numero){
    const $loader = document.getElementById('loader');
    $loader.style.display = "flex"

    let products = [];
 
    const qtyAdult = parseInt(
        String(
            document.getElementById(`${numero}-qty`)?.value ??
            document.getElementById(`${numero}-qty`)?.textContent ??
            "0"
        ).trim(),
    10) || 0;

    const qtyNino = parseInt(
        String(
            document.getElementById(`${numero}-child`)?.value ??
            document.getElementById(`${numero}-child`)?.textContent ??
            "0"
        ).trim(),
    10) || 0;

    const totalPax = qtyAdult + qtyNino;

    // Format date — computed before products so it can be added as line-item property
    let fechaValor = document.getElementById("dateInput").value;
    const [m, d, y] = fechaValor.split("/");
    fechaValor = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;

        //Numero 6 es Fiesta dominincana
        if(numero == 6){

          if (qtyAdult > 0) {
              products.push({
                  id: '50542557135131',
                  quantity: qtyAdult,
                  properties: { 'Fecha': fechaValor }
              });
          }


          if (qtyNino > 0) {
              products.push({
                  id: '52327636009243',
                  quantity: qtyNino,
                  properties: { 'Fecha': fechaValor }
              });
          }
          //Numero 7 Herencia
        }else if(numero == 7){

          if (qtyAdult > 0) {
              products.push({
                  id: '50542490583323',
                  quantity: qtyAdult,
                  properties: { 'Fecha': fechaValor }
              });
          }


          if (qtyNino > 0) {
              products.push({
                  id: '52327499399451',
                  quantity: qtyNino,
                  properties: { 'Fecha': fechaValor }
              });
          }
        }

     await clearCart();

    for (const p of products) {
        await addToCart([p], fechaValor);
    }
    
    if(document.getElementById('includesTransport').checked){        
        jsonReservas.token = token;
       await addTicketToCart(jsonTransporte);        
    }
    location.href = "/cart?finish&note=" + fechaValor + "&token=" + 7584562545;
}



 async function clearCart() {
    return await fetch('/cart/clear.js', { method: 'POST' })
        .then((response) => {
            if (!response.ok) throw new Error('Error al limpiar el carrito');
            return response.json();
        })
        .then((data) => {
            return true; // Confirmamos que se limpió correctamente
        })
        .catch((error) => {
            console.error('Error al limpiar el carrito:', error);
            return false; // En caso de error, retornamos false
        });
}


async function addTicketToCart(jsonTransporte) {
  
  const payload = {
    items: [jsonTransporte],
  };

  const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(`Fallo al agregar al carrito (${res.status}): ${txt}`);
  }

  const json = await res.json();
  if (json?.status === 422) {
    alert('Producto agotado o no disponible.');
  }

  await createReserva(jsonReservas);

  return json;
}


 async function addToCart(items, fecha) {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "items": items, "note": fecha })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const json = await response.json();

        // Validación de error cuando el producto está agotado
        if (json.status === 422) {
            Swal.fire({
                title: 'Producto agotado.'
            });
        } else {
            // Redirección opcional al carrito (comentada)
            // window.location.replace('/cart');
        }

    } catch (error) {
        throw error;
    }
  }

  function arreglarLinksDatepicker() {
  document.querySelectorAll('.ui-datepicker-prev, .ui-datepicker-next').forEach(function(el) {
    // Forzamos javascript:void(0) en los botones de cambio de mes: jQuery UI vuelve a emitir
    // estos <a href="#"> en cada onChangeMonthYear, y con href="#" el click navega al fragmento
    // vacío y hace scroll del landing a la home. void(0) anula el default sin tostar el click
    // (jQuery UI sigue manejándolo para cambiar de mes vía su propio binding).
    el.setAttribute('href', 'javascript:void(0)');
  });
}